<template>
	<div class="rounded-2xl overflow-hidden">
		<div class="w-full overflow-hidden flex flex-col justify-stretch">
			<div
				class="relative h-60 md:h-96 flex flex-row items-end md:justify-start"
				:class="props.data.right ? 'justify-end' : ''"
			>
				<img
					:src="props.data.photo"
					alt="Image description"
					class="absolute inset-0 w-full h-full object-cover"
					loading="lazy"
					style="aspect-ratio: 1 / 1 !important"
				/>
				<div class="relative z-10 text-primary text-vc-header bg-white rounded-full m-4 py-2 px-4">
					{{ props.data.title }}
				</div>
			</div>
		</div>
		<div class="bg-accent-red-0.25 p-4 leading-tight h-full">
			{{ props.data.text }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'TextPhotoBubbleComponent',
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	setup(props) {
		console.log(props)
		return {
			props
		}
	}
}
</script>
